module.exports = __webpack_public_path__ + "img/tx_950.ffd1be9b.jpg";